import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Typography,
  CardMedia,
  Card,
  Button,
} from "@mui/material";
import { rsParentCom, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooter } from "./UseFooter";
import { useNavigate, useLocation } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import useBreakpoints from "../../../hooks/useBreakpoints";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { readFromLS } from "../../../util/LocalStrogeService";

export default function FooterInpho() {
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooter, SetFooter } = UseFooter();
  const [state, setState] = useState({
    id: undefined,
    urL1: undefined,
    description: undefined,
    descriptionTitle: undefined,
    websiteLicense: undefined,
    websiteLicenseURL: undefined,
  });
  const { isSmall } = useBreakpoints();
  const [homePageId, setHomePageid] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : ""
  );
  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
  });

  const handleChangeImage1 = (file) => {
    setImgState({
      imageFile1: file[0],
      imageUrl1: URL.createObjectURL(file[0]),
    });
  };

  useEffect(() => {
    setProgress(true);
    GetFooter(
      homePageId?.id ? homePageId.id : 1,
      (footer) => {
        setImgState({
          ...imgState,
          imageUrl1: footer.logo1 ? footer.logo1 : "",
        });
        setState({
          id: footer.id ? footer.id : "",
          urL1: footer.urL1 ? footer.urL1 : "",
          websiteLicenseURL: footer.websiteLicenseURL
            ? footer.websiteLicenseURL
            : "",
          description: footer.description ? footer.description : "",
          websiteLicense: footer.websiteLicense ? footer.websiteLicense : "",
          descriptionTitle: footer.descriptionTitle
            ? footer.descriptionTitle
            : "",
        });
      },
      true
    );
  }, [homePageId]);

  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
      <Box gridColumn="span 12" sx={{ display: "flex", alignItems: "center" }}>
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
          اطلاعات فوتر
        </Typography>
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 2"}>
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage1(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "150px", height: "auto" }}>
              <Card
                sx={{
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                  bgcolor: "#d3d3d3",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.imageUrl1
                      ? imgState.imageUrl1
                      : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          sx={{
            textarea: { direction: "rtl" },
          }}
          multiline
          maxRows={4}
          value={state.urL1 ? state.urL1 : ""}
          label="لینک تصویر"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, urL1: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          value={state.websiteLicense ? state.websiteLicense : ""}
          label="مجوز وب سایت"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, websiteLicense: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          value={state.websiteLicenseURL ? state.websiteLicenseURL : ""}
          label="لینک مجوز وب سایت"
          sx={{
            input: {
              direction: "rtl",
            },
          }}
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, websiteLicenseURL: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          value={state.descriptionTitle ? state.descriptionTitle : ""}
          label="عنوان توضیحات"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, descriptionTitle: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn="span 12">
        {/* <TextField
          fullWidth
          value={state.description ? state.description : ""}
          label=" توضیحات"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, description: evt.target.value });
          }}
          multiline
          rows={4}
          InputLabelProps={{
            shrink: true,
          }}
        /> */}
        <Typography sx={{ mb: 1 }} variant="subtitle1" color="secondary">
          توضیحات
        </Typography>
        <CKEditor
          config={{
            language: "fa",
            link: {
              decorators: {
                addTargetToExternalLinks: {
                  mode: "automatic",
                  callback: (url) => /^(https?:)?\/\//.test(url),
                  attributes: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
              },
            },
          }}
          editor={Editor}
          data={state.description}
          style={{ p: "100px", width: "100%" }}
          onChange={(event, editor) => {
            if (state.id) {
              const data = editor.getData();
              setState({ ...state, description: data });
            }
          }}
          onReady={(editor) => {
            editor.editing.view.change((writer) => {
              writer.setStyle(
                "height",
                "150px",
                editor.editing.view.document.getRoot()
              );
            });
          }}
        />
      </Box>

      <Box
        gridColumn="span 12"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Button
          sx={{ mr: 2, width: "100px" }}
          variant="contained"
          onClick={() => {
            //   if (validateItem(state, setErrorState) == 200) {
            setProgress(true);
            SetFooter(state, imgState.imageFile1, (calback) => {
              navigate("/homepagemanage", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            });
            //   }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
